<template>
  <v-slide-y-transition>
    <v-card-text v-show="show" >
      <v-layout style="border: solid; border-color:gray;">
        <v-flex class="text-xs-left subheading">

          <v-layout row wrap>
            <v-flex xs11 sm4 ><v-text-field  label="Order ID" v-model="orderID"> </v-text-field></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 sm3 md2 ><v-radio-group label="Show orders:" v-model="orderState">
              <v-radio label="Open" value="OPEN"></v-radio>
              <v-radio label="Closed" value="CLOSED"></v-radio>
              <v-radio label="All" value="BOTH"></v-radio>
            </v-radio-group>
            </v-flex>

            <v-flex xs6 sm3 lg2>
              <v-select
                v-model="daysSelector"
                :items="lastXDays"
                label="Within"
              ></v-select>
            </v-flex>
            <v-flex xs6 sm4 lg2>
              <div v-if="daysSelector === 'custom'">
              <v-menu
                ref="startDateMenu"
                :close-on-content-click="false"
                v-model="startDateMenu"
                :nudge-right="40"
                :return-value.sync="startDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDate"
                  label="From"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="startDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="$refs.startDateMenu.save(startDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="endDateMenu"
                :close-on-content-click="false"
                v-model="endDateMenu"
                :nudge-right="40"
                :return-value.sync="endDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="endDate"
                  label="To"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="endDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="$refs.endDateMenu.save(endDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              </div>
            </v-flex>
          </v-layout>
          <v-btn class="accent" :loading="ordersLoading" @click="search">Search</v-btn>
          <v-btn flat class="" @click="clear">Clear</v-btn>
        </v-flex>
        <div>

        </div>
      </v-layout>

    </v-card-text>
  </v-slide-y-transition>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'OrderSearchSettings',
  props: ['show'],
  components: {
  },
  data () {
    return {
      daysSelector: 7,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,
      orderID: null,
      orderState: 'BOTH',
      showSearch: false,
      lastXDays: [
        {text: '7 days', value: 7},
        {text: '30 days', value: 30},
        {text: '60 days', value: 60},
        {text: '180 days', value: 180},
        {text: 'Custom Range', value: 'custom'}
      ]
    }
  },
  computed: {
    ...mapState({
      orders: state => state.admin.orders,
      uid: state => state.admin.uid,
      queryCriteria: state => state.admin.queryCriteria,
      ordersLoading: state => state.admin.ordersLoading
    })

  },
  mounted: function () {
    // Setup the query criteria
    this.orderID = this.queryCriteria.orderID
    this.orderState = this.queryCriteria.orderState || 'BOTH'
    this.startDate = this.queryCriteria.startDate
    this.endDate = this.queryCriteria.endDate
    this.daysSelector = this.queryCriteria.daysSelector || 180

    if (!this.orders || this.orders.length === 0) {
      this.loadOrders()
    }
  },
  watch: {
    uid: function (val) {
      this.loadOrders()
    }
  },
  methods: {
    clear: function () {
      this.startDate = null
      this.endDate = null
      this.orderID = null
      this.orderState = 'BOTH'
      this.daysSelector = 7
    },
    search: function () {
      this.loadOrders()
    },
    loadOrders: function () {
      const queryCriteria = {
        orderID: this.orderID,
        orderState: this.orderState,
        startDate: this.startDate,
        endDate: this.endDate,
        daysSelector: this.daysSelector
      }

      return this.$store.dispatch('admin/watchOrders', {
        'queryCriteria': queryCriteria
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
